{
  "version": 1,
  "asset_id": "e62de74a-56cb-46cc-b6dc-aab70d965514",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e62de74a-56cb-46cc-b6dc-aab70d965514/sleeve-hiatal-type-1-es-600.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e62de74a-56cb-46cc-b6dc-aab70d965514/sleeve-hiatal-type-1-es-600.webp",
  "original_filename": "sleeve-hiatal-type-1-es-600.webp",
  "size": 32858,
  "content_type": "image/webp",
  "created_at": "2026-09-26T21:38:49Z"
}
